/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";

import { useState } from "react";
import { subscribeToNewsletter } from "../actions/newsletter";

export default function NewsletterForm() {
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");

  async function handleSubmit(formData: FormData) {
    try {
      const result = await subscribeToNewsletter(formData);
      setMessage(result.message);
      setStatus(result.success ? "success" : "error");
    } catch (error) {
      setMessage("An unexpected error occurred. Please try again.");
      setStatus("error");
    }
  }

  return (
    <div className="max-w-2xl mx-auto">
      <div className="mx-4 p-6 bg-white/5 rounded-lg shadow-md my-6">
        <h2 className="text-2xl font-bold mb-4">Subscribe to my newsletter</h2>
        <form action={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label
                htmlFor="firstName"
                className="block text-sm font-medium text-gray-100"
              >
                First Name
              </label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                required
                className="mt-1 block w-full bg-white/5 px-3 py-2 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
              />
            </div>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-100"
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                required
                className="mt-1 block w-full bg-white/5 px-3 py-2 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
              />
            </div>
          </div>
          <button
            type="submit"
            className="w-full md:w-auto px-8 bg-pink-500 text-white py-2 rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            Subscribe
          </button>
        </form>
        {message && (
          <div
            className={`mt-4 p-4 rounded-md ${
              status === "success"
                ? "bg-green-50 text-green-800"
                : "bg-red-50 text-red-800"
            }`}
          >
            {message}
          </div>
        )}
      </div>
    </div>
  );
}
